import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';
import { SharingVendorIntegration } from '../entity';
import { SharingVendorIntegrationId } from '../value';

export abstract class ISharingVendorIntegrationRepository extends IRepository<SharingVendorIntegrationId, SharingVendorIntegration> {
  abstract selectAll(builder: FirestoreQueryBuilder<SharingVendorIntegration>): Observable<SharingVendorIntegration>;
}
